module.exports = __webpack_public_path__ + "static/media/work1.95d2822c.webp";